const GWM_LIST = ["sub2", "postback"]

// eslint-disable-next-line flowtype/no-weak-types
export function loadFromSession(): Object {
  if (navigator.cookieEnabled && window.sessionStorage) {
    return GWM_LIST.reduce(
      (acc, key) => ({
        ...acc,
        [key]: window.sessionStorage.getItem(key),
      }),
      {},
    )
  }
  return {}
}

// eslint-disable-next-line flowtype/no-weak-types
export function saveToSession(object: Object): void {
  if (navigator.cookieEnabled && window.sessionStorage) {
    Object.keys(object)
      .filter(key => GWM_LIST.includes(key))
      .forEach(key => {
        window.sessionStorage.setItem(key, object[key])
      })
  }
}
